<div class="container">
  <div class="text-center">
    <strong class="mainHeading">Order Summary Report</strong>
  </div>

  <div class="d-flex justify-content-between mt-2">
    <div class="d-flex justify-content-start gap-2 flex-grow-1">
      <div class="col-md-2">
        <label for="userType" class="form-label">Type of user</label>
        <select
          id="userType"
          class="form-select"
          (change)="onUserTypeChange($event)"
        >
          <option value="">All</option>
          <option *ngFor="let type of userTypeList" [value]="type.id">
            {{ type.userType }}
          </option>
        </select>
      </div>
      <div class="col-md-2">
        <label for="city" class="form-label">City</label>
        <select id="city" class="form-select" (change)="onCityChange($event)">
          <option value="">All Cities</option>
          <option *ngFor="let city of cityList" [value]="city.id">
            {{ city.cityName }}
          </option>
        </select>
      </div>
      <div class="col-md-2">
        <label for="zone" class="form-label">Zone</label>
        <select id="zone" class="form-select" (change)="onZoneChange($event)">
          <option value="">All Zones</option>
          <option *ngFor="let zone of zoneList" [value]="zone.zoneName">
            {{ zone.zoneName }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <div class="row d-flex">
    <div class="col-lg-2 col-md-2 col-sm-12">
      <div class="card shadow cardRadius p-3 mt-3">
        <h1 class="text-center fs-3" style="color: #008ffb">
          <strong>{{ totalSarReceivedFromRequester }}</strong>
        </h1>
        <p class="text-center">SAR Received From Requester</p>
      </div>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-12">
      <div class="card shadow cardRadius p-3 mt-3">
        <h1 class="text-center fs-3" style="color: #ff4560">
          <strong>{{ totalSarAllocatedToDumpster }}</strong>
        </h1>
        <p class="text-center">SAR Allocated to Dumpster</p>
      </div>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-12">
      <div class="card shadow cardRadius p-3 mt-3">
        <h1 class="text-center fs-3" style="color: #7fb519">
          <strong>{{ totalSarAllocatedToDumpyard }}</strong>
        </h1>
        <p class="text-center">SAR Allocated to Dumpyard</p>
      </div>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-12">
      <div class="card shadow cardRadius p-3 mt-3">
        <h1 class="text-center fs-3" style="color: #d50000">
          <strong>{{ totalSarRefundedToRequester }}</strong>
        </h1>
        <p class="text-center">SAR Refunded To Requester</p>
      </div>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-12">
      <div class="card shadow cardRadius p-3 mt-3">
        <h1 class="text-center fs-3" style="color: #ff6f00">
          <strong>{{ totalSarAllocatedToSmartsort || 0 }}</strong>
        </h1>
        <p class="text-center">SAR Allocated to Smart-sort</p>
      </div>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-12">
      <div class="card shadow cardRadius p-3 mt-3">
        <h1 class="text-center fs-3" style="color: #64dd17">
          <strong>{{ totalQuantityDisposed }}</strong>
        </h1>
        <p class="text-center">Total Quantity Disposed</p>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-md-3">
      <div class="card" style="height: 90vh; overflow-y: auto">
        <div class="card-body">
          <strong style="color: #00270e" class="fs-5">User List</strong>
          <div class="mt-3">
            <input
              id="search"
              type="text"
              class="form-control"
              placeholder="Search"
              [(ngModel)]="searchText"
              (ngModelChange)="filterUsers()"
            />
          </div>

          <!-- Scrollable user list container -->
          <div class="user-list-scroll mt-2">
            <ul class="list-group user-list">
              <li
                *ngFor="let user of filteredUserList"
                style="cursor: pointer"
                class="list-group-item d-flex justify-content-start align-items-center"
                (click)="getUsersById(user)"
              >
                <div class="d-flex align-items-center">
                  <div>
                    <div class="d-flex align-items-center">
                      <i class="bi bi-person-fill me-2"></i>
                      <strong>{{
                        user.userType === "1" ? user.userName : user.companyName
                      }}</strong>
                    </div>
                    <div class="d-flex align-items-center">
                      <i class="bi bi-telephone-fill me-2"></i>
                      {{ user.phoneNo }}
                    </div>
                    <div class="d-flex align-items-center">
                      <i class="bi bi-person-bounding-box me-2"></i>
                      <small>{{ getType(user.userType) }}</small>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <h3 class="text-center" *ngIf="filteredUserList?.length < 1">
              <strong>Select the User type.!!</strong>
            </h3>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-9">
      <div class="card shadow-lg p-3">
        <!-- Buttons (Export and Print) -->
        <div class="d-flex align-items-center justify-content-between">
          <h2 class="mb-0" style="color: #00270e">
            <strong>
              {{
                selectedUserTypeId == "1"
                  ? selectedUserName
                  : selectedCompanyName || "All"
              }}
              Records
            </strong>
          </h2>

          <!-- Wrap buttons in a div and push them to the end -->
          <div class="ms-auto d-flex">
            <button
              class="btn btn-outline-secondary"
              type="button"
              ngbTooltip="Export"
              (click)="exportToExcel()"
            >
              <span><i class="bi bi-box-arrow-up me-2"></i></span> Export
            </button>

            <button
              class="btn btn-outline-secondary ms-2"
              type="button"
              ngbTooltip="Print"
              (click)="exportToPDF()"
            >
              <span><i class="bi bi-printer me-2"></i></span> Print
            </button>
          </div>
        </div>

        <div class="table-responsive mt-2" style="overflow-x: auto">
          <!-- Date Pickers in Same Line -->
          <div class="d-flex align-items-center gap-3 mb-2">
            <!-- From Date Picker -->
            <div class="col-auto">
              <label for="fromDate" class="form-label mb-0 me-2"
                >From Date</label
              >
              <input
                type="date"
                id="fromDate"
                class="form-control"
                [(ngModel)]="fromDate"
                (change)="onDateChange('from', $event)"
              />
            </div>

            <!-- To Date Picker -->
            <div class="col-auto">
              <label for="toDate" class="form-label mb-0 me-2">To Date</label>
              <input
                type="date"
                id="toDate"
                class="form-control"
                [(ngModel)]="toDate"
                (change)="onDateChange('to', $event)"
                [disabled]="!isDateShow"
              />
            </div>
          </div>

          <table class="table table-bordered table-striped mt-3">
            <thead class="thead-light">
              <tr>
                <th>OrderId</th>
                <th>City</th>
                <th>Zone</th>
                <th>Scheduled Start Date</th>
                <th>Scheduled End Date</th>
                <th>Number Of Weeks</th>
                <th>Number Of Container Booked</th>
                <th>Planned Trips</th>
                <th>Actual Trips</th>
                <th>SAR Received From Requester</th>
                <th>SAR Allocated To Dumpster</th>
                <th>SAR Allocated To Dumpyard</th>
                <th>SAR Allocated To Smartsort</th>
                <th>SAR Refunded To Requester</th>
                <th>Total Quantity Disposed (Cu.M)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of orderSummaryData">
                <td>{{ data.orderId }}</td>
                <td>{{ data.city }}</td>
                <td>{{ data.zone }}</td>
                <td>{{ data.scheduleStartDate | date : "dd MMM yyyy" }}</td>
                <td>{{ data.scheduleEndtDate | date : "dd MMM yyyy" }}</td>
                <td>{{ data.numberOfWeeks }}</td>
                <td>{{ data.numberOfContainers }}</td>
                <td>{{ data.plannedTrips }}</td>
                <td>{{ data.actualTrips }}</td>
                <td>{{ data.sarReceivedFromRequester }}</td>
                <td>{{ data.sarAllocatedToDumpster }}</td>
                <td>{{ data.sarAllocatedToDumpyard }}</td>
                <td>{{ data.sarAllocatedToSmartsort }}</td>
                <td>{{ data.sarRefundedToRequester }}</td>
                <td>{{ data.totalQuantityDisposed }}</td>
              </tr>
              <tr *ngIf="orderSummaryData?.length < 1">
                <td colspan="15" class="text-center">No Data Found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
